import { useQuery } from '@tanstack/react-query'

import { getRewardPointTransactions } from '@src/api'
import { DefaultApiGetRewardPointTransactionsRequest } from '@src/api/generated/user-api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'

export const useFetchRewardPointTransactions = (
  params: DefaultApiGetRewardPointTransactionsRequest
) => {
  const { axiosInstance } = useAxios()

  return useQuery({
    enabled: !!params.organizationId,
    queryFn: () => getRewardPointTransactions(axiosInstance, params),
    queryKey: [REACT_QUERY_CACHE_KEYS.GET_REWARD_POINT_TRANSACTIONS],
  })
}
